'use client';

// types
import type { DownloadcenterProps } from 'features/download-center/components/types';

// components
import Downloadcenter from 'features/download-center/components/group/downloadcenter';
import Layout from 'scenes/Group/Layout';

// utils
import { contentExists, useContent } from 'components/Page/page-hooks';

export interface DownloadCenterGroupProps extends DownloadcenterProps {
  metaData: MetaData;
}

export default function DownloadCenterGroup(props: Readonly<DownloadCenterGroupProps>) {
  const pageContent = useContent<
    {},
    {
      filterTypeOrder: Record<string, number>;
      filterOrder: Record<string, number>;
      filterMediaOrder: Record<string, number>;
      mediaFilter: string;
    }
  >();

  if (!contentExists(pageContent)) {
    return null;
  }

  // if user calls the dlc page directly then we use the props from the server
  // if the dlc page is created in cms then we combine the props from the server
  // with the props from the tpp
  const { breadcrumbs, page, contentAreas, metaData } = { ...props, ...pageContent };
  return (
    <Layout metaData={metaData}>
      <Downloadcenter page={page} contentAreas={contentAreas} breadcrumbs={breadcrumbs} />
    </Layout>
  );
}
